var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "green",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.205 22.2813L19.1633 28.6147L16.9029 24.8438C16.455 24.1042 15.4967 23.8647 14.7571 24.3126C14.0175 24.7605 13.7779 25.7188 14.2258 26.4584L17.3508 31.6667C17.5696 32.0417 17.9446 32.3022 18.3612 32.3959C18.4654 32.4167 18.58 32.4272 18.6842 32.4272C19.0071 32.4272 19.3196 32.3334 19.58 32.1459L29.9967 24.8542C30.705 24.3647 30.8717 23.3855 30.3821 22.6772C29.8925 21.9688 28.9133 21.7813 28.205 22.2813Z",
    fill: "green"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6005_9487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "green"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6005_9487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4587 38.3332C9.55171 38.3332 7.06803 37.3269 5.00762 35.3144C2.9472 33.3019 1.91699 30.8422 1.91699 27.9353C1.91699 25.4436 2.66769 23.2234 4.16908 21.2748C5.67046 19.3262 7.63505 18.0804 10.0628 17.5373C10.8614 14.5984 12.4587 12.2186 14.8545 10.3978C17.2503 8.57692 19.9656 7.6665 23.0003 7.6665C26.7378 7.6665 29.9083 8.96824 32.5118 11.5717C35.1153 14.1752 36.417 17.3457 36.417 21.0832C38.6212 21.3387 40.45 22.2891 41.9035 23.9342C43.3569 25.5794 44.0837 27.504 44.0837 29.7082C44.0837 32.104 43.2451 34.1405 41.568 35.8175C39.891 37.4946 37.8545 38.3332 35.4587 38.3332H24.917C23.8628 38.3332 22.9604 37.9578 22.2097 37.2071C21.459 36.4564 21.0837 35.554 21.0837 34.4998H24H35.4587C36.8003 34.4998 37.9344 34.0366 38.8607 33.1103C39.7871 32.1839 40.2503 31.0498 40.2503 29.7082C40.2503 28.3665 39.7871 27.2325 38.8607 26.3061C37.9344 25.3797 36.8003 24.9165 35.4587 24.9165H32.5837V21.0832C32.5837 18.4318 31.6493 16.1717 29.7805 14.303C27.9118 12.4342 25.6517 11.4998 23.0003 11.4998C20.3489 11.4998 18.0889 12.4342 16.2201 14.303C14.3514 16.1717 13.417 18.4318 13.417 21.0832H12.4587C10.6059 21.0832 9.02463 21.738 7.71491 23.0478C6.40519 24.3575 5.75033 25.9387 5.75033 27.7915C5.75033 29.6443 6.40519 31.2255 7.71491 32.5353C9.02463 33.845 10.6059 34.4998 12.4587 34.4998H17.2503V38.3332H12.4587Z",
    fill: "green"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheck);
export default __webpack_public_path__ + "static/media/cloud-check.39538c096a6fa08e9849973fa52b6220.svg";
export { ForwardRef as ReactComponent };